import axios from 'axios';
import router from "@/router";
import { applyTenantHeader } from '@/utils/tenant';
import { extractTraceId, showTraceError } from '@/utils/trace-error';
import { clearCache } from '@/services/user.service';

let maxTime = process.env.MAX_REQ_TIME; 
let baseUrl = process.env.VUE_APP_BASE_URL;

if (process.env.NODE_ENV === 'production') {
    baseUrl = window.globalConfig.rootUrl;
}

// 创建请求服务
const serves = axios.create({
    baseURL: baseUrl,
    timeout: maxTime
})

// 设置请求发送之前的拦截器
serves.interceptors.request.use(config => {
    applyTenantHeader(config);
    return config
}, err => {Promise.reject(err)})

// 设置响应拦截器
serves.interceptors.response.use(response => { 
    if (response.status === 200 || response.status === 204) {
        return Promise.resolve(response.data)
    } else {
        // 如果请求失败，则统一处理错误
        return Promise.reject(response)
    }
}, err => {
    // 取出状态码和消息
    let message = '';
    let status = getStatus(err);

    // 区分真实 401 和网络错误
    const isReal401 = err.response && err.response.status === 401;
    const isNetworkError = err.message && err.message.indexOf("Network Error") != -1;

    let msg = err.response && err.response.data && err.response.data.error ? (
        err.response.data.error.code ? err.response.data.error.code : err.response.data.error.details ? err.response.data.error.details :
        err.response.data.error.message ? err.response.data.error.message :
        err.response.data.error_description ? err.response.data.error_description :
        status + '错误') : status + '错误';

    // 提取 TraceId
    let traceId = extractTraceId(err);

    // 判断请求时发生的错误类型，处理不同的错误
    switch (status) {
        case 400:
            message = msg ? msg : '访问失效，请重新登陆';
            break;
        case 401:
            // 只有真正的 401 才跳登录页，网络错误不跳转
            if (isReal401) {
                message = '登录已过期，请重新登录';
                clearCache();
                if (router.currentRoute.path !== '/login') {
                    router.push('/login');
                }
            } else if (isNetworkError) {
                message = '网络连接错误，请检查网络后重试';
            } else {
                message = '无访问权限';
            }
            break;
        case 406:
            message = '应用未激活或已过有效期';
            router.push('/app-register');
            break;
        case 403:
            message = msg ? msg :'请求错误';
            break;
        case 415:
            message = '参数格式错误';
            break;
        case 500:
            message = msg ? msg : '接口发生错误';
            break;
        case 504:
            message = '请求超时';
            break;
        default:
            message = msg ? msg : `请求错误`;
            break;
    }
    showTraceError(message, traceId, status);
    return Promise.reject(message)
})

function getStatus(err) {
    if (err.message && err.message.indexOf("Network Error") != -1) {
        return 401;
    }
    if (err.code && err.code == 'ECONNABORTED') {
        return 504;
    }
    let status = err.response && err.response.status ? err.response.status : 403;
    return status;
}

export { serves as default, baseUrl }